import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { SIGNIN, AGREE_TO_EULA, GET_APP_URL, FORGOT_PWD } from "./types";
import { push } from "connected-react-router";
import moment from "moment";
import firebase from "firebase/app";
import "firebase/auth";
export var navigateToDashboard = function navigateToDashboard() {
  return function (dispatch) {
    dispatch(push("/dashboard"));
  };
};
export var login = function login() {
  var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var password = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var date, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (email === false || password === false) {
                dispatch({
                  type: SIGNIN.FAIL
                });
              }

              dispatch({
                type: SIGNIN.REQUEST
              });
              _context.prev = 2;
              date = moment().format("DD-MM-YYYY HH:mm:ss");
              _context.next = 6;
              return firebase.auth().signInWithEmailAndPassword(email, password);

            case 6:
              result = _context.sent;
              firebase.database().ref("/users/".concat(result.user.uid, "/profile")).once("value", function (snapshot) {
                if (snapshot === null) {
                  dispatch({
                    type: SIGNIN.FAIL
                  });
                } else {
                  var profile = snapshot.val();
                  firebase.database().ref("/collections/seated_user_limit").on("value", function (snap) {
                    var limit = snap.val();
                    firebase.database().ref("/collections/seated_users").on("value", function (snap) {
                      var users = snap.val();

                      if (profile.email.toLowerCase().includes("prowork") || typeof limit === "undefined" || limit === null) {
                        firebase.database().ref("/users/".concat(result.user.uid, "/profile")).update({
                          last_active_dashboard: date
                        }, function (error) {
                          if (error === null) {
                            dispatch({
                              type: SIGNIN.SUCCESS,
                              payload: snapshot.val()
                            });
                            dispatch(getAppUrl());
                          } else {
                            console.log(error);
                          }
                        });
                      } else {
                        console.log("is required");

                        if (!users.includes(profile.uid)) {
                          firebase.auth().signOut();
                          dispatch({
                            type: SIGNIN.FAIL
                          });
                          dispatch(push("/login"));
                        } else {
                          firebase.database().ref("/users/".concat(result.user.uid, "/profile")).update({
                            last_active_dashboard: date
                          }, function (error) {
                            if (error === null) {
                              dispatch({
                                type: SIGNIN.SUCCESS,
                                payload: snapshot.val()
                              });
                              dispatch(getAppUrl());
                            } else {
                              console.log(error);
                            }
                          });
                        }
                      }
                    });
                  });
                }
              }, function (error) {
                console.log(error);
                dispatch({
                  type: SIGNIN.FAIL
                });
              });
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              dispatch({
                type: SIGNIN.FAIL
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 10]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var getAppUrl = function getAppUrl() {
  return function (dispatch) {
    dispatch({
      type: GET_APP_URL.REQUEST
    });
    firebase.auth().onAuthStateChanged(function (user) {
      if (user === null) {
        dispatch({
          type: GET_APP_URL.FAIL
        });
      } else {
        firebase.database().ref("/collections/app_store_link").on("value", function (snapshot) {
          if (snapshot === null) {
            dispatch({
              type: GET_APP_URL.FAIL
            });
          } else {
            dispatch({
              type: GET_APP_URL.SUCCESS,
              payload: snapshot.val()
            });
          }
        });
      }
    });
  };
};
export var agreeToEula = function agreeToEula() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var date;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch({
                type: AGREE_TO_EULA.REQUEST
              });
              date = moment().format("DD-MM-YYYY HH:mm:ss");

              try {
                firebase.auth().onAuthStateChanged(function (user) {
                  if (user === null) {
                    dispatch({
                      type: AGREE_TO_EULA.FAIL
                    });
                    dispatch(push("/login"));
                  } else {
                    firebase.database().ref("/users/".concat(user.uid, "/profile")).update({
                      agreed_to_eula: "Yes",
                      agreed_to_eula_timestamp: date
                    }, function (error) {
                      if (error === null) {
                        dispatch({
                          type: AGREE_TO_EULA.SUCCESS
                        });
                        dispatch(push("/dashboard"));
                      } else {
                        dispatch({
                          type: AGREE_TO_EULA.FAIL
                        });
                      }
                    });
                  }
                });
              } catch (e) {
                dispatch({
                  type: AGREE_TO_EULA.FAIL
                });
              }

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var forgotPwd = function forgotPwd(email) {
  return function (dispatch) {
    dispatch({
      type: FORGOT_PWD.REQUEST
    });

    try {
      if (email) {
        firebase.auth().sendPasswordResetEmail(email);
      }
    } catch (e) {
      dispatch({
        type: FORGOT_PWD.FAIL
      });
    }
  };
};